import React from "react";
import { useLocation } from "react-router-dom";

interface BookingConfirmationProps {
  orderDetails: any;
}

const BookingConfirmation: React.FC<BookingConfirmationProps> = () => {
  const location = useLocation();
  const { orderDetails } = location.state;

  return (
    <div className="container booking-confirmation">
      <h2>Booking Confirmed</h2>
      <p>Order Number: {orderDetails.orderNumber ?? "N/A"}</p>
      <p>Customer Name: {orderDetails.customerName ?? "N/A"}</p>
      {orderDetails.guestNames && orderDetails.guestNames.length > 0 && (
        <p>Guest Names: {orderDetails.guestNames.join(", ")}</p>
      )}
      <p>Company Name: {orderDetails.companyName ?? "N/A"}</p>
      <p>Address: {orderDetails.address ?? "N/A"}</p>
      <p>Address 2: {orderDetails.address2 ?? "N/A"}</p>
      <p>City: {orderDetails.city ?? "N/A"}</p>
      <p>State: {orderDetails.state ?? "N/A"}</p>
      <p>Zip Code: {orderDetails.zipCode ?? "N/A"}</p>
      <p>Country: {orderDetails.country ?? "N/A"}</p>
      <p>Phone: {orderDetails.phone ?? "N/A"}</p>
      <p>Email: {orderDetails.email ?? "N/A"}</p>
      <p>Booking Description: {orderDetails.bookingDescription ?? "N/A"}</p>
      <p>Total Price: €{orderDetails.totalPrice ?? "N/A"}</p>
      <h3>Bookings:</h3>
      {orderDetails.bookings && orderDetails.bookings.length > 0 ? (
        <ul>
          {orderDetails.bookings.map((booking: any, index: number) => (
            <li key={index}>
              <p>Package Name: {booking.packageName ?? "N/A"}</p>
              <p>
                Arrival Date:{" "}
                {booking.arrivalDate
                  ? new Date(booking.arrivalDate).toLocaleDateString()
                  : "N/A"}
              </p>
              <p>
                Departure Date:{" "}
                {booking.departureDate
                  ? new Date(booking.departureDate).toLocaleDateString()
                  : "N/A"}
              </p>
              <p>Total Cost: €{booking.totalCost ?? "N/A"}</p>
              <p>Address: {booking.address ?? "N/A"}</p>
              <p>Address 2: {booking.address2 ?? "N/A"}</p>
              <p>City: {booking.city ?? "N/A"}</p>
              <p>Zip Code: {booking.zipCode ?? "N/A"}</p>
              <p>Country: {booking.country ?? "N/A"}</p>
              <p>Phone: {booking.phone ?? "N/A"}</p>
              <p>Email: {booking.email ?? "N/A"}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p>No bookings available.</p>
      )}
    </div>
  );
};

export default BookingConfirmation;
